/** 旧版报告整图 URL */
export function isLegacyReportImageUrl(authenticate) {
  if (authenticate == null || authenticate === "") return false;
  const s = String(authenticate).trim();
  return (
    s.startsWith("http://") ||
    s.startsWith("https://") ||
    s.startsWith("/")
  );
}

/** 鉴别订单（xw_order）是否可预览小程序同款报告 */
export function canPreviewXwOrderReport(row) {
  if (!row || row.id == null) return false;
  if (Number(row.status) < 3) return false;
  if (row.reportIssuedAt) return true;
  if (isLegacyReportImageUrl(row.authenticate)) return true;
  return row.jbjg != null && row.jbjg !== "";
}

/** jbjg：1 通过，0 不通过；未完成鉴别返回空 */
export function xwOrderJbjgResultLabel(row) {
  if (!row || Number(row.status) < 3) return "";
  if (row.jbjg == null || row.jbjg === "") return "";
  return Number(row.jbjg) === 1 ? "通过" : "不通过";
}

export function xwOrderJbjgResultColor(row) {
  const label = xwOrderJbjgResultLabel(row);
  if (!label) return "#909399";
  return label === "通过" ? "#67C23A" : "#F56C6C";
}

/** 寄售/鉴别订单（xw_order 列表行）是否可修改已出具鉴别结果（列表侧仅按订单字段判断，作业 id 点击时再查） */
export function canEditXwOrderInspection(row) {
  if (!row || row.id == null) return false;
  const status = Number(row.status);
  // 5=已退款 10=已取消；出具报告后（status>=3）均可修改，含寄回/寄售后续状态
  if (status < 3 || status === 5 || status === 10) return false;
  if (Number(row.isClosed) === 1) return false;
  if (!row.reportIssuedAt && (row.jbjg == null || row.jbjg === "")) return false;
  if (row.jbjg == null || row.jbjg === "") return false;
  return Number(row.jbjg) === 0 || Number(row.jbjg) === 1;
}



// WEBPACK FOOTER //
// ./src/util/xwOrderReport.js